import gql from 'graphql-tag';

export const PLACE_FRAGMENT = gql`
	fragment place on Place {
		id
		name
		directions
		requiresAccessPass
		accessPassDetails
		requiredEquipment
		visualDirectionPhotos {
			id
			link
			comment
		}
		visualDirectionPhotoUrls
		location {
			id
			name
			addressObj {
				id
				region
				street
				city
				postcode
			}
			accessHours
			directions
			requiresAccessPass
			requiresSignIn
			signInInstructions
			accessPassDetails
			requiredEquipment
			coordinates
			visualDirectionPhotos {
				id
				link
				comment
			}
			visualDirectionPhotoUrls
			rootTenantId
		}
		commission {
			id
			name
			type
			value
		}
		salesToday
		salesYesterday
		salesLast7Days
		salesLast7DaysAth
		salesLast7DaysAthDate
		salesLastMonth
		salesLastQuarter
		salesLastYear
		rootTenantId
		machineCount
		machines {
			id
			assetId
			type
		}
		serviceGroup {
			id
			name
			location {
				id
				name
			}
			machines {
				id
				assetId
				type
			}
		}
	}
`;

export const GET_PLACES = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: PlacePageFilter
	) {
		getPlaces(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...place
			}
			count
		}
	}
	${PLACE_FRAGMENT}
`;

const GET_PLACES_FOR_MULTI_SELECT_FRAGMENT = gql`
	fragment placeForMultiSelect on Place {
		id
		name
		location {
			id
			name
		}
		machines {
			id
			assetId
			type
		}
	}
`;

export const GET_PLACES_FOR_MULTI_SELECT = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: PlacePageFilter
	) {
		getPlaces(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...placeForMultiSelect
			}
			count
		}
	}
	${GET_PLACES_FOR_MULTI_SELECT_FRAGMENT}
`;

export const CREATE_PLACE = gql`
    mutation createPlaceMutation($input: CreatePlaceInput!) {
        createPlace(input: $input) {
            ...place
        }
	}
	${PLACE_FRAGMENT}
`;

export const DESTROY_PLACE = gql`
	mutation destroyPlaceMutation ($id: ID!) {
		destroyPlace(id: $id)
	}
`;


export const GET_PLACE = gql`
	query($id: String) {
		getPlace(id: $id) {
			...place
		}
	}
	${PLACE_FRAGMENT}
`;

export const MODIFY_PLACE = gql`
	mutation modifyPlaceMutation($input: ModifyPlaceInput!) {
		modifyPlace(input: $input) {
			place {
				...place
			}
		}
	}
	${PLACE_FRAGMENT}
`;

export const SUBSCRIBE_TO_PLACE = gql`
	subscription ($input: PlaceSubscriptionInput!) {
		PlaceSubscription(input: $input) {
			place {
				...place
			}
			destroyedPlaceId
		}
	}
	${PLACE_FRAGMENT}
`;

export const GET_PLACES_COUNT = gql`
	query {
		countPlaces
	}
`;

export const GET_ACCESS_PASS_PLACES = gql`
	query getAccessPassPlaces(
		$page: Int,
		$perPage: Int,
		$sortBy: String,
		$sortDirection: Int,
		$filter: PlacePageFilter
	) {
		getPlaces(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				name
				accessPassDetails
				location {
					id
					name
				}
			}
			count
		}
	}
`;
